export const convertUndefinedToNull = <T extends Record<string, unknown>>(obj: T) => {
  const clone = {} as T
  Object.entries(obj).forEach(([key, value]) => {
    if (value === undefined) {
      ;(clone as Record<string, unknown>)[key] = null
    } else {
      ;(clone as Record<string, unknown>)[key] = obj[key]
    }
  })
  return clone
}
